<script>
import {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    HomeIcon,
    UserIcon,
    UserCheckIcon,
    MailIcon,
    KeyIcon
} from 'vue-feather-icons';
import appConfig from "@/app.config";
import axios from 'axios';

// 초기세팅
function initialState() {
  return {
    member: {
      id: "",
      pw: "",
      nick: "",
      name: "",
    }
  };
}


export default {
  data() {
    return {
      appConfig: appConfig,
      ...initialState(),
    };
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    HomeIcon,
    UserIcon,
    UserCheckIcon,
    MailIcon,
    KeyIcon
  },
  metaInfo() {
    return {
      title: '관리자 회원가입 | 대구여성인권센터',
      meta: [
        {
          name: 'description',
          content: '대구여성인권센터 관리자 회원가입 페이지입니다. 최고관리자 승인 후 가입이 완료됩니다.'
        },
        {
          property: 'og:title',
          content: '관리자 회원가입 | 대구여성인권센터'
        },
        {
          property: 'og:description',
          content: '대구여성인권센터 관리자 회원가입 페이지입니다. 최고관리자 승인 후 가입이 완료됩니다.'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: '관리자 회원가입 | 대구여성인권센터'
        },
        {
          name: 'twitter:description',
          content: '대구여성인권센터 관리자 회원가입 페이지입니다. 최고관리자 승인 후 가입이 완료됩니다.'
        }
      ]
    }
  },
  methods: {
    // 초기화
    resetWindow: function (){
      Object.assign(this.$data, initialState());
    },
    // 가입완료 버튼 검증
    submit_singup() {
      // 모든 칸 채워진건지 확인
      if (this.member.id !=='' && this.member.pw !=='' && this.member.nick !=='' && this.member.name !=='') {
        this.c_member_signup()
      } else {
        this.$notify({ type: 'error', duration: 4000, title: '실패', text: '모든 칸을 채워주세요' })
      }
    },
    // 가입완료 API로 전송
    async c_member_signup() {
      try {
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/c_member_signup',
          data: {
            "mb_id": this.member.id,
            "mb_pw": this.member.pw,
            "mb_nick": this.member.nick,
            "mb_name": this.member.name,
          },
        })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '회원가입이 신청되었습니다. 관리자 승인을 기다리세용'})
            this.$router.push('/'); // 메인페이지로 이동
          } else {
            this.$notify({ type: 'error', duration: 5000, 'title': res.data.status+' 에러2', text: res.data.detail })
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 5000, 'title': error.response.status+' 에러3', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의' })
      }
    },
  }
};
</script>

<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <router-link to="/" class="btn btn-icon btn-primary">
        <home-icon class="icons"></home-icon>
      </router-link>
    </div>

    <!-- Hero Start -->
    <section class="bg-derc-member navwave-2 d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-6">
            <div class="media features p-4 bg-primary rounded mr-lg-5">
              <router-link class="logo-footer" to="/">
                <div class="text-bold text-white">
                  <img :src="`${appConfig.url}/images/_decen/logo/logo_old.png`" width="24" alt="" />대구여성인권센터
                </div>
                <div>
                  <span><i class="mdi mdi-shield-edit-outline img-fluid mx-auto d-block member-login-img mover text-primary"></i></span>
                </div>
              </router-link>
            </div>
          </div>
          <div class="col-lg-5 col-md-6">
            <div class="card shadow rounded border-0">
              <div class="card-body">
                <h4 class="card-title text-center text-bold text-primary">관리자 회원 가입</h4>
                <span class="text-mute font-size-13 text-bold text-center d-block mb-3">(최고관리자 승인 후 가입이 완료됩니다)</span>
                <div class="login-form mt-4">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label for="id">아이디 <span class="text-danger">*</span> <span class="text-mute font-size-11">(로그인시 사용할 아이디입니다)</span></label>
                        <div class="position-relative">
                          <user-icon class="fea icon-sm icons"></user-icon>
                          <input type="text" class="form-control pl-5" placeholder="아이디를 적어주세요" v-model="member.id" id="id" name="id" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label for="password">비밀번호 <span class="text-danger">*</span> <span class="text-mute font-size-11">(8자리 이상 입력해주세요)</span></label>
                        <div class="position-relative">
                          <key-icon class="fea icon-sm icons"></key-icon>
                          <input type="password" class="form-control pl-5" placeholder="비밀번호를 적어주세요"  v-model="member.pw" id="password" name="password" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label for="nickname">글쓴이명 <span class="text-danger">*</span> <span class="text-mute font-size-11">(글쓸때 보여지는 이름입니다 중복가능)</span></label>
                        <div class="position-relative">
                          <user-check-icon class="fea icon-sm icons"></user-check-icon>
                          <input type="text" class="form-control pl-5" placeholder="ex) 인권센터" v-model="member.nick" id="nickname" name="nickname" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group ">
                        <label for="name">별명 또는 실명 <span class="text-danger">*</span> <span class="text-mute font-size-11">(관리자 구분용입니다. 중복가능)</span></label>
                        <div class="position-relative">
                          <user-icon class="fea icon-sm icons"></user-icon>
                          <input type="text" class="form-control pl-5" placeholder="ex) 홍길순" v-model="member.name" id="name" name="name" required="">
                        </div>
                      </div>
                    </div>
                    <!-- 관리자 가입이라 이용약관이 필요없지 -->
                    <!--
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheck1">
                          <label class="custom-control-label" for="customCheck1">이용약관에 <span class="text-primary">동의 합니다.</span></label>
                        </div>
                      </div>
                    </div>
                    -->
                    <div class="col-md-12">
                      <button @click="submit_singup()" class="btn btn-primary btn-block">회원가입 신청</button>
                    </div>
                    <div class="mx-auto">
                      <p class="mb-0 mt-3"><small class="text-dark mr-2">이미 계정이 있으신가요?</small>
                        <router-link to="/member-login" class="text-primary font-weight-bold">로그인하기</router-link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
